import { render, staticRenderFns } from "./NotDriverMonthlyCreateScore.vue?vue&type=template&id=6e571ed8&"
import script from "./NotDriverMonthlyCreateScore.vue?vue&type=script&lang=js&"
export * from "./NotDriverMonthlyCreateScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports